import { DeathlyHallowsIcon } from './DeathlyHallowsIcon';

/**
 * author: Michael Richins
 * id BC446853-45C9-4374-8980-579BCD93355A
 * name deathly-hallows
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/deathly-hallows.svg
 * tags
 */
export const HarryPotterIcon = DeathlyHallowsIcon;
export default HarryPotterIcon